import Color from 'color';
import { STYLE_PROPERTIES_TYPES } from '../handlers/constants';
export const isColorStyleProperty = propertyType => {
  return Object.values(STYLE_PROPERTIES_TYPES.COLOR).includes(propertyType);
};
export const isNumberStyleProperty = propertyType => {
  return Object.values(STYLE_PROPERTIES_TYPES.NUMBER).includes(propertyType);
};
export const mapStyleParamToTpaStyleParam = _ref => {
  let {
    key,
    value,
    siteColors,
    type
  } = _ref;
  if (isColorStyleProperty(type)) {
    try {
      if (typeof value === 'object' && value.preset) {
        var _siteColors$find;
        const hexValue = (_siteColors$find = siteColors.find(siteColor => siteColor.name === value.preset)) == null ? void 0 : _siteColors$find.value;
        if (!hexValue) {
          console.error(`no site color name ${value.preset} found.`);
          return undefined;
        }
        let rgbaValue = Color(hexValue).rgb().toString();
        if (value.opacity) {
          rgbaValue = Color(hexValue).alpha(value.opacity).rgb().toString();
        }
        return {
          type: 'color',
          key,
          param: {
            value: {
              opacity: value.opacity,
              rgba: rgbaValue,
              color: {
                name: value.preset,
                value: rgbaValue
              }
            }
          }
        };
      }
      const colorObj = Color(value);
      return {
        type: 'color',
        key,
        param: {
          value: {
            opacity: colorObj.alpha(),
            rgba: colorObj.rgb().string(),
            color: false
          }
        }
      };
    } catch (error) {
      console.error(`Failed to process color value:`, error);
      return undefined;
    }
  }
  if (isNumberStyleProperty(type)) {
    const tpaValue = parseFloat(value);
    return {
      type: 'number',
      key,
      param: {
        value: tpaValue
      }
    };
  }
  console.error('no mapping for style param', key, type, value);
  return undefined;
};
//# sourceMappingURL=OOIStyles.js.map